<script lang="ts" setup>
import { computed } from 'vue';
import resolveConfig from 'tailwindcss/resolveConfig';
// @ts-expect-error: Kan niet zomaar js in ts importeren maakt voor hier niks uit
import tailwindConfig from '@tailwind-config';

type Shade = 'grey' | 'primary';

const { progress, shade = 'grey' } = defineProps<{
  progress: number;
  shade?: Shade;
}>();

const fullConfig = resolveConfig(tailwindConfig);
const tailwindColors: Record<string, string> = Object.entries(fullConfig.theme.colors).reduce(
  (obj, [key, value]) => {
    if (typeof value === 'object' && value != null) {
      Object.entries(value).forEach(([variant, definition]) => {
        obj[`${key}-${variant}` as `${string}-${string}`] = definition as string;
      });
    } else if (typeof value === 'string') {
      obj[key] = value;
    }
    return obj;
  },
  {} as Record<string, string>,
);

const shadeMapping: Record<Shade, { color1: string; color2: string }> = {
  grey: { color1: tailwindColors['grey-500'], color2: tailwindColors['grey-600'] },
  primary: { color1: tailwindColors['primary-500'], color2: tailwindColors['primary-600'] },
};

const progressWidth = computed(() => `${Math.min(100, progress)}%`);
const color1 = computed(() => shadeMapping[shade].color1);
const color2 = computed(() => shadeMapping[shade].color2);
const barWidth = '3em';
const transitionTimePerBar = '1s';
</script>
<template>
  <div class="rounded-lg bg-grey-200">
    <div class="progress-bar h-4 rounded-lg"></div>
  </div>
</template>
<style>
.progress-bar {
  width: v-bind(progressWidth);

  --color1: v-bind(color1);
  --color2: v-bind(color2);
  --animated-bar-length: v-bind(barWidth);
  --transition-time-per-bar: v-bind(transitionTimePerBar);

  --double-bar-length: calc(var(--animated-bar-length) * 2);
  --background-length: calc(100% + (var(--animated-bar-length) * (3 / 1.05)));

  background: repeating-linear-gradient(
      45deg,
      var(--color1) 0,
      var(--color1) var(--animated-bar-length),
      var(--color2) var(--animated-bar-length),
      var(--color2) var(--double-bar-length)
    )
    right;
  background-size: var(--background-length) 100%;
  will-change: background-position;
  animation: progress-bar-animation calc(var(--transition-time-per-bar) * 2) linear infinite;
}

@keyframes progress-bar-animation {
  0% {
    background-position: right;
  }
  100% {
    background-position: left;
  }
}
</style>
